
import React from 'react';
import HeroSlider from './HomeComponents/HeroSlider';
import HomeStripeText from './HomeComponents/StripContent';
import WhoWeAre from './HomeComponents/HowWeAre';
import InvestaServices from './HomeComponents/Services';
import ProjectListing from './HomeComponents/ProjectsListing';
import PropertyListing from './HomeComponents/PropertyListing';
import Citizenship from './HomeComponents/Citizenship';
import ClientMessages from './HomeComponents/ClientMessages';
import Contact from './HomeComponents/Contact';

const Home: React.FC = () => {
  
  return (
        <section id="home" className='pdless'> 
          <HeroSlider />
          <HomeStripeText />
          <WhoWeAre />
          <InvestaServices />
          <ProjectListing />
          <PropertyListing />
          <Citizenship />
          <ClientMessages />
          <Contact />
        </section>
    )

}

export default Home;